import { TOGGLE_SIDEBAR } from './actionType';

const initalState = {
  showSidebar: false
}

const reducer = (state = initalState, action) => {
  switch (action.type) {
    case TOGGLE_SIDEBAR:
      return {
        ...state,
        showSidebar: !state.showSidebar
      }
    default:
      return state
  }
}

export default reducer